import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import './Dashboard.css';
import { API_BASE_URL } from '../config';

// const API_BASE_URL = 'http://localhost:3001/api';

function Dashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [recentTreatments, setRecentTreatments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const [statsRes, treatmentsRes] = await Promise.all([
        axios.get(`${API_BASE_URL}/dashboard/stats`, { withCredentials: true }),
        axios.get(`${API_BASE_URL}/treatments/recent?limit=10`, { withCredentials: true })
      ]);

      if (statsRes.data.success) {
        setStats(statsRes.data.stats);
      }

      if (treatmentsRes.data.success) {
        setRecentTreatments(treatmentsRes.data.treatments);
      }
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="dashboard-loading">Loading dashboard...</div>;
  }

  return (
    <div className="dashboard-page">
      <div className="dashboard-header">
        <h1>Dashboard</h1>
        <p className="welcome-text">Welcome back, {user?.fullName || 'User'}!</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">📋</div>
          <div className="stat-content">
            <div className="stat-value">{stats?.total_treatments || 0}</div>
            <div className="stat-label">Total Treatments</div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">🏡</div>
          <div className="stat-content">
            <div className="stat-value">{stats?.total_herds || 0}</div>
            <div className="stat-label">Herds Managed</div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">🐄</div>
          <div className="stat-content">
            <div className="stat-value">{stats?.total_cows || 0}</div>
            <div className="stat-label">Cows Treated</div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">📅</div>
          <div className="stat-content">
            <div className="stat-value">{stats?.days_active || 0}</div>
            <div className="stat-label">Active Days</div>
          </div>
        </div>
      </div>

      <div className="recent-activity">
        <h2>Recent Treatments</h2>
        {recentTreatments.length === 0 ? (
          <div className="empty-state">
            <p>No treatments recorded yet. Start by digitizing a treatment card!</p>
          </div>
        ) : (
          <div className="treatments-table">
            <table>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Herd ID</th>
                  <th>Life Number</th>
                  <th>Cow Number</th>
                  <th>Farm</th>
                  <th>Created By</th>
                </tr>
              </thead>
              <tbody>
                {recentTreatments.map((treatment) => (
                  <tr key={treatment.id}>
                    <td>{treatment.treatment_date}</td>
                    <td>{treatment.herd_id}</td>
                    <td>{treatment.life_number}</td>
                    <td>{treatment.cow_number}</td>
                    <td>{treatment.farm_name || '-'}</td>
                    <td>{treatment.creator?.full_name || 'Unknown'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
